/**
 * Remembers the last campaigns-list page across routes so "up" navigation from
 * a campaign (the in-app back button and the "Campaign" breadcrumb crumb) can
 * return to the list at the page the user left — independent of browser history
 * (which we deliberately leave to step through tabs). sessionStorage keeps it
 * per-tab and clears when the tab closes.
 *
 * `scope` separates lists that share one page component (e.g. admin's
 * all-campaigns list and each brand's list), so page 4 of one list is never
 * reused for another. Omitted, it is the single unscoped list.
 */
const KEY = 'discovr.campaignsListPage';

const storageKey = (scope?: string): string => (scope ? `${KEY}:${scope}` : KEY);

export function setLastCampaignsListPage(page: number, scope?: string): void {
  try {
    if (page > 1) {
      sessionStorage.setItem(storageKey(scope), String(page));
    } else {
      sessionStorage.removeItem(storageKey(scope));
    }
  } catch {
    // Private mode / storage disabled — up-nav just falls back to page 1.
  }
}

/** Last list page (>= 1), or undefined when unset — callers omit `?page` then. */
export function getLastCampaignsListPage(scope?: string): number | undefined {
  try {
    const raw = sessionStorage.getItem(storageKey(scope));
    if (!raw) return undefined;
    const n = Number.parseInt(raw, 10);
    return Number.isInteger(n) && n > 1 ? n : undefined;
  } catch {
    return undefined;
  }
}
